<app-modal-form #modal [modalConfig]="modalConfig" [modalOptions]="modalOptions">
  <app-section-loader *ngIf="isLoading" class="modal-detail-distributor__loader" />

  <app-card-empty
    *ngIf="hasError"
    [icon]="STRING_CONSTANTS.ICON.IC_DISTRIBUTOR_NONE"
    text="Detail distributor tidak dapat dimuat."
  />

  <!--
    `ng-content` sengaja TIDAK dibungkus `*ngIf`: content projection hanya terjadi sekali,
    jadi node yang dilepas saat kondisi false tidak akan kembali saat modal dibuka lagi.
    Yang di-toggle adalah visibilitasnya, bukan keberadaannya di DOM.
  -->
  <div [class.d-none]="isLoading || hasError" class="modal-detail-distributor__body">
    <!-- [MAI-2601] Enam kartu ringkasan. -->
    <app-summary-detail-distributor
      (openInvoiceDetail)="openInvoiceDetail.emit()"
      (openOtherRewards)="openOtherRewards.emit()"
      [detail]="detail"
      [isSingleLevelProgram]="payload?.isSingleLevelProgram ?? false"
    />

    <!-- [MAI-2606] Section Detail Produk. -->
    <app-section-detail-produk
      [distributorId]="payload?.distributorId ?? ''"
      [hasSpecificProductTarget]="detail?.is_specific_target ?? false"
      [targetDistributorId]="payload?.targetDistributorId ?? ''"
    />

    <!-- Slot tambahan untuk card berikutnya. -->
    <ng-content></ng-content>

    <!--
      [MAI-2608 AC-01] Banner potensi PO. Tampil hanya jika distributor punya PO Siap
      Diproses / Diproses Sebagian, dan tidak pernah tampil pada program berstatus Selesai.
    -->
    <!--
      `text` sengaja tidak dikirim: pada cabang `extraContent` + `text`, `app-note-view`
      memasang `handleTextColor(color)` sebagai kelas pembungkus ("gray-900" untuk info),
      sehingga latar biru `.note-view.info` tidak pernah aktif. Cabang tanpa `text` memasang
      `color` apa adanya, jadi teks banner dirender di dalam slot ini.
    -->
    <app-note-view
      *ngIf="hasPotentialPo"
      [classNoteView]="''"
      [color]="'info'"
      [extraContent]="true"
      [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION"
    >
      <div class="d-flex align-items-center justify-content-between">
        <span class="modal-detail-distributor__banner-text">{{ potentialPoText }}</span>
        <button
          (click)="openPotentialPo.emit()"
          class="modal-detail-distributor__link"
          type="button"
        >
          <u>Lihat PO</u>
        </button>
      </div>
    </app-note-view>
  </div>
</app-modal-form>
